<template>
  <v-app id="app">
    <router-view />
    <v-snackbar v-model="snackbar.isVisible" :color="snackbar.color" content-class="text-center">
      {{ snackbar.message }}
    </v-snackbar>
  </v-app>
</template>
<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState(['snackbar']),
    },
  }
</script>

<style lang="scss">
  body {
    background: url('https://img.freepik.com/free-photo/constellations-dark_34629-883.jpg?size=626&ext=jpg') !important;
    background-repeat: repeat-y;
  }

  html {
    overflow: hidden !important;
  }
  .scrollable {
    overflow-y: auto !important;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background: url('https://img.freepik.com/free-photo/constellations-dark_34629-883.jpg?size=626&ext=jpg') !important;
    background-repeat: repeat-y;
    padding-bottom: 20px;
  }

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }

  /* SCROLLBAR */

  /* width */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track-piece {
    background-color: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgba(49, 43, 43, 0.5);
    border-radius: 50px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: rgba(81, 78, 78, 0.5);
  }
</style>
